import Loading from '@/components/loading';
import './index.scss';

export interface PageLoadingProps {
  loading: boolean;
}

const PageLoading: React.FC<PageLoadingProps> = ({ loading }) => {
  return (
    <div className="csc-page-loading">
      <Loading loading={loading} type="hll" size="huge" className="csc-page-loading-box" />
    </div>
  );
};

export default PageLoading;
